<template>
  <div class="home">
    <main role="main" class="ml-sm-auto col-xl-10 px-4">
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">Gestion des statuts</h1>
    </div>
    <div class="row">
      <div class="col mt-4 mt-xl-0 order-1 order-xl-0">
        <div class="row mb-2">
          <div class="col">
            <button class="btn btn-success btn-sm" @click="ResetNew">Creer</button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <MyVuetable ref="vuetable" @detailsRow="detailsRow" url="status" :fields="fields" :sortOrder="sortOrder"></MyVuetable>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-4 border order-xl-12 order-0" v-if="idInt || showEditor">
        <StatusEditor :id="id" @onUpdate="onUpdate" @onDelete="onDelete"></StatusEditor>
      </div>
    </div>
    </main>
  </div>
</template>

<script>
/* global $ */
import MyVuetable from '@/components/MyVuetable'
import StatusEditor from '@/components/StatusEditor'

export default {
  components: {
    MyVuetable,
    StatusEditor
  },
  props: {
    id: String,
    showEditor: Boolean
  },
  data () {
    return {
      fields: [
        {
          name: 'nom',
          sortField: 'nom',
          title: 'Nom'
        },
        {
          name: 'ordre',
          sortField: 'ordre',
          title: 'Ordre'
        },
        '__slot:details'
      ],
      sortOrder: [
        {
          field: 'ordre',
          direction: 'asc'
        }
      ]
    }
  },
  computed: {
    idInt() {
      if(!isNaN(parseInt(this.id))) {
        return parseInt(this.id)
      }

      return null
    }
  },
  methods: {
    ResetNew(){
      this.$router.replace( { name:'statusManagerNew' })
    },
    detailsRow(rowData) {
      this.$router.replace({name:'statusManager',params: { id: rowData.id }})
    },
    onUpdate() {
      this.$refs.vuetable.refresh()
      $(window).scrollTop(0);
    },
    onDelete() {
      this.$router.push({ name:'statusManager' }).catch(() => {})
    }
  },
  watch:
  {
    id () {
      this.$refs.vuetable.refresh()
      $(window).scrollTop(0);
    }
  }
}
</script>
